import "./App.css";
import CustomCursor from "./Component/CustomCursor";
import Header from "./Component/Header";
import Home from "./Pages/Home";

function App() {
  return (
    <div>
      {/* <Header /> */}
      <CustomCursor />
      <Home />
    </div>
  );
}

export default App;
